define([
    "./remoteServerModule",
    "./RemoteServerModalController",
    "./remoteServerModalService",
    "./remoteServerModule",
    "./remoteServerService",
    "./remoteServerUrls",
], function () {
});